import { FC, useMemo } from 'react'
import { LoadingPage } from '../../../components/shared/loading/LoadingPage/LoadingPage.component'
import { useLoginStellair } from '../../../hooks/queries/vitalCard'
import { consumeStellairOAuthCode } from '../../../misc/Stellair/stellair.oauth.utilities'

export const StellairOAuthPage: FC = () => {
  const code = useMemo(() => consumeStellairOAuthCode(), [])

  useLoginStellair({ code })

  return <LoadingPage title="Authentification Stellair en cours..." />
}
